import React, { useEffect, useState } from 'react';
import AdminView from '../components/AdminView';
import Header from '../components/Header';

const AdminDashboard = () => {

    const [vendorData, setVendorData] = useState([])

    useEffect(() => {
        fetch('https://vendor-managed-inventory-transparency.onrender.com/vendor-inventory-stock')
            .then(response => response.json())
            .then(data => {
                setVendorData(data.result.reverse())
            })
            .catch(err => console.log(err))
    }, [])

    return (
        <div className='bg-brand'>
            <div className="container">
                <h1 className='pt-3 text-center fw-bold'><span className='fs-4 d-none d-lg-block'>Vendor Manage Inventory Transparency</span><span className='fs-6 d-lg-none'>Vendor Manage Inventory Transparency</span></h1>

                <Header />

                <h2 className='py-3 fs-5 ps-2'>Admin Dashboard</h2>
                {
                    vendorData.length > 0 ? <AdminView outlet={vendorData} /> : <p>Loading...</p>
                }
            </div>
        </div>
    );
};

export default AdminDashboard;